export const Success              = 0
export const Error                = 1
export const ErrorInvalidJwt      = 3
export const ErrorUnauthenticated = 4
export const ErrorESign           = 5

export const ErrorDBOperation    = 10
export const ErrorLoginAccount   = 100
export const ErrorLoginPassword  = 101
export const ErrorUpdatePassword = 102
export const ErrorSendSms        = 106
export const ErrorVerifyCode     = 107

export const ErrorUpdateUser     = 116

export const ErrorRegisterLogin         = 120
export const ErrorRegisterExist         = 121
export const ErrorRegisterAdd           = 122
export const ErrorRegisterESignNoAuth   = 123
export const ErrorRegisterESignNotExist = 124
export const ErrorRegisterESign         = 129

export const ErrorESignNotExist = 1435203